import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { PlatformCheckerService } from '@services/platform-checker/platform-checker.service';

@Component({
  selector: 'app-generic-info-modal',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
  templateUrl: './generic-info-modal.component.html',
  styleUrls: ['./generic-info-modal.component.scss'],
})
export class GenericInfoModalComponent {
  @Input() public title = '';
  @Input() public infoAsHTML = '';
  @Input() public infoAsList: { title?: string; description?: string }[] = [];
  @Input() public mobileHeaderTitle = 'WORKING_DAY.TITLE';
  @Input() public iconSrc = 'assets/icon/info.svg';

  public constructor(
    private readonly modalController: ModalController,
    private readonly platformCheckerService: PlatformCheckerService
  ) {}

  public onDismissModal(): void {
    this.modalController.dismiss();
  }

  public isMobile(): boolean {
    return this.platformCheckerService.isMobile();
  }
}
